import apiClient from "./axiosInstanceVessel";

export const createVessel = async (addData) => {
  return await apiClient.post("/api/vessels/", addData);
};

export const getAllVessel = async () => {
  return await apiClient.get(`/api/vessels`);
};

export const getVessel = async (vesselNumber) => {
  return await apiClient.get(`/api/vessels/${vesselNumber}`);
};

export const getVesselsByOwner = async (userId) => {
  return await apiClient.get(`/api/vessels/owner/${userId}`);
};


export const addCrewMember = async (addData) => {
  return await apiClient.post('/api/vessels/update-crew', addData);
};

